export default __webpack_public_path__ + "static/bg-left-swirl-5a2e3b6de1b5a3ba3033befec1b2deff.png";